module.exports = __webpack_public_path__ + "img/home--why-choose@2x.14a096e1.jpg";